module.exports = __webpack_public_path__ + "static/media/cosplay1.28ec1c71.jpg";